<span style="font-size: 12px;">{{ utc | date:'mediumDate' }}</span><br/>
<em style="font-size: 10px;">{{ utc | date: 'shortTime' }}</em>
